
import { computed, defineComponent, PropType } from 'vue'

// components
import Cheap from '@/common/components/UI/Cheap/index.vue'

// constants
import { TRIPS_STATUSES } from '@/core/constants/tms.constants'

import { formatDateWithTimeFromBackend, formatDateFromBackend } from '@/common/helpers/formatDate'

export default defineComponent({
    props: {
        row: {
            type: Object as PropType<any>,
            default: null,
        },
        column: {
            type: Object as PropType<any>,
            default: null,
        },
        index: {
            type: Number,
            required: true,
        },
    },
    components: { Cheap },
    setup(props) {
        const getDepartureDate = (departureDate: string | null) => {
            if (departureDate) {
                const parts = departureDate.split('T')
                return `${formatDateFromBackend(parts[0])} ${parts[1]}`
            }

            return null
        }

        const getCheapTitle = computed(() => {
            if (!props.row) return '-'
            if (props.row.isEarlyCompleted) return 'Завершен'
            if (props.row.isDelayed) return 'Опаздывает'

            return props.row.status.name
        })

        const getCheapClass = computed(() => {
            let className = 'small '

            if (!props.row) return className

            if (props.row.isEarlyCompleted) {
                className += 'green'
            } else if (props.row.isDelayed) {
                className += 'red'
            } else if (props.row.status) {
                className += TRIPS_STATUSES[props.row.status.id - 1]
            }

            return className
        })

        const isDirection = computed(() => {
            return (
                props.column &&
                props.row &&
                props.column.key === 'direction' &&
                props.row.fromCity &&
                props.row.toCity
            )
        })

        const getCheckOrTimesIcon = (is_check: boolean) =>
            `fas ${is_check ? 'fa-check text-green-500' : 'fa-times'}`

        return {
            getDepartureDate,
            getCheapTitle,
            getCheapClass,
            isDirection,
            getCheckOrTimesIcon,
            //
            TRIPS_STATUSES,
            formatDateWithTimeFromBackend,
        }
    },
})
